import i18n from "i18next";
import i18nBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Supported language codes - must match the codes in survey/api.ts
export const SUPPORTED_LANGUAGE_CODES = [
  "en",
  "fr",
  "ko",
  "vi",
  "zh",
  "th",
  "es",
  "ru",
  "hi",
];

i18n
  .use(LanguageDetector)
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    load: "languageOnly",
    fallbackLng: "en",
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    detection: {
      // Order of language detection methods - querystring has highest priority
      order: ["querystring", "navigator", "htmlTag"],
      // Look for 'language' query parameter (e.g., ?language=zh)
      lookupQuerystring: "language",
      // Don't cache detected language
      caches: [],
    },
  });

export default i18n;
